module.exports = {
  pt: { back: 'Voltar' },
  en: { back: 'Go Back' }
}
